import NFTFilter from '@/app/shared/explore-nft/nft-filter';
import NFTGrid from '@/app/shared/explore-nft/nft-grid';

export default function NFTSearchPageView() {
  return (
    <>
      <NFTFilter />
      <NFTGrid />
    </>
  );
}
